let initialState = null;

function comparison_tariff(state = initialState, action) {
    if (action.type === "REMOVE_COMPARISON_TARIFF") return action.res;
    else if (action.type === "RESET_COMPARISON_TARIFF") return action.res;
    else return state;
}
export default comparison_tariff;
